import React, { useState } from "react";
import Replicate_Testing_Form from "./replicate_Testing_Form/Replicate_Testing_Form";
import Replicate_Testing_table from "./replicate_Testing_table/Replicate_Testing_table";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function Replicate_Testing({ validitydetails, setCurrentPage, currentPage,openDeleteModal }) {
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
                                          
  const haveReadPermission = permissions?.includes(FixIDS.ensuring_the_validity.List);
  const haveAddPermission = permissions?.includes(FixIDS.replicate_testing.Add); //form


  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <Replicate_Testing_Form
          validityTypeId={3}
          onProceed={() => setShowTable(true)}
        />}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <Replicate_Testing_table
         openDeleteModal={openDeleteModal}
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          validityTypeId={3}
        /> }
      </div>
      {/* )} */}
    </>
  );
}

export default Replicate_Testing;
